module.exports = __webpack_public_path__ + "img/card-afrigo.e8d38371.svg";